import React from "react";
import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  TextField,
} from "@mui/material";
import { fonts, textFieldStyles } from "../../../../../Styles/Styles";

const Filter = ({
  roles,
  selectedRole,
  emailVerified,
  idVerified,
  onRoleChange,
  onEmailVerifiedChange,
  onIdVerifiedChange,
  searchQuery,
  onSearchChange,
  sortOrder,
  onSortOrderChange,
}) => {
  return (
    <Box sx={{ mb: 3, width: "100%" }}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={3}>
          <TextField
            label="Search by Name or Email"
            variant="outlined"
            size="small"
            fullWidth
            value={searchQuery}
            onChange={onSearchChange} // Pass search input handler
            sx={{ ...textFieldStyles }}
          />
        </Grid>
        {/* Role Filter */}
        <Grid item xs={12} sm={3}>
          <FormControl fullWidth variant="outlined" size="small">
            <InputLabel sx={{ ...fonts }}>Filter by Role</InputLabel>
            <Select
              value={selectedRole}
              onChange={(e) => onRoleChange(e.target.value)}
              label="Filter by Role"
              sx={{ ...fonts }}
            >
              <MenuItem value="" sx={{ ...fonts }}>
                All
              </MenuItem>
              {roles.map((role) => (
                <MenuItem key={role} value={role} sx={{ ...fonts }}>
                  {role === "superAdmin" ? "Super Admin" : "User"}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        {/* Sort by Created Date */}
        <Grid item xs={12} sm={3}>
          <FormControl fullWidth variant="outlined" size="small">
            <InputLabel sx={{ ...fonts }}>Created Date</InputLabel>
            <Select
              value={sortOrder}
              onChange={(e) => onSortOrderChange(e.target.value)} // Handling sort
              label="Created Date"
              sx={{ ...fonts }}
            >
              <MenuItem value="" sx={{ ...fonts }}>
                None
              </MenuItem>
              <MenuItem value="asc" sx={{ ...fonts }}>
                Ascending
              </MenuItem>
              <MenuItem value="desc" sx={{ ...fonts }}>
                Descending
              </MenuItem>
            </Select>
          </FormControl>
        </Grid>

        {/* Email Verified Filter */}
        <Grid item xs={12} sm={3}>
          <FormControl fullWidth variant="outlined" size="small">
            <InputLabel sx={{ ...fonts }}>Email Verified</InputLabel>
            <Select
              value={emailVerified}
              onChange={(e) => onEmailVerifiedChange(e.target.value)}
              label="Email Verified"
              sx={{ ...fonts }}
            >
              <MenuItem value="" sx={{ ...fonts }}>
                All
              </MenuItem>
              <MenuItem value="true" sx={{ ...fonts }}>
                Yes
              </MenuItem>
              <MenuItem value="false" sx={{ ...fonts }}>
                No
              </MenuItem>
            </Select>
          </FormControl>
        </Grid>

        {/* ID Verified Filter */}
        <Grid item xs={12} sm={3}>
          <FormControl fullWidth variant="outlined" size="small">
            <InputLabel sx={{ ...fonts }}>ID Verified</InputLabel>
            <Select
              value={idVerified}
              onChange={(e) => onIdVerifiedChange(e.target.value)}
              label="ID Verified"
              sx={{ ...fonts }}
            >
              <MenuItem value="" sx={{ ...fonts }}>
                All
              </MenuItem>
              <MenuItem value="true" sx={{ ...fonts }}>
                Yes
              </MenuItem>
              <MenuItem value="false" sx={{ ...fonts }}>
                No
              </MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Filter;
